import { NgModule } from '@angular/core';
import { BoxTabsComponent } from './box-tabs/box-tabs.component';
import { BoxTabComponent } from './box-tabs/box-tab/box-tab.component';
import { SharedModule } from '../shared/shared.module';



@NgModule({
  declarations: [BoxTabsComponent, BoxTabComponent],
  imports: [
    SharedModule
  ],
  exports:[
    BoxTabsComponent
  ]
})
export class TabsModule { }
